import { ProductTableEditButton } from './ProductTableEditButton';

export default ProductTableEditButton;